import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
import { Button, PriceDisplay } from './ui';
export const Pricing = () => {
  return <section className="py-10 md:py-20 px-4 bg-brand-charcoal text-white" data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <h2 className="font-nunito font-extrabold text-3xl md:text-5xl text-center mb-8" data-id="element-133">
          Entonces, ¿Cuánto Vale Todo Esto?
        </h2>

        <div className="bg-white text-brand-charcoal rounded-3xl p-5 md:p-12 shadow-2xl" data-id="element-134">
          <div className="space-y-3 mb-5 font-inter text-base md:text-lg" data-id="element-135">
            <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-136">
              <span className="font-semibold" data-id="element-137">
                Guía Principal "Cómo Ayudar a Tu Hijo con la Constipación"
              </span>
              <span className="text-gray-400" data-id="element-138">
                Valor <PriceDisplay amount="25.000" data-id="element-139" />
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-140">
              <span data-id="element-141">Bono #1: Plan de Alimentación Anti-Constipación</span>
              <span className="text-gray-400" data-id="element-142">
                Valor <PriceDisplay amount="8.000" data-id="element-143" />
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-144">
              <span data-id="element-145">Bono #2: Recetas Prácticas Para El Tránsito</span>
              <span className="text-gray-400" data-id="element-146">
                Valor <PriceDisplay amount="6.000" data-id="element-147" />
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-148">
              <span data-id="element-149">Bono #3: Checklist Semanal de Hábitos</span>
              <span className="text-gray-400" data-id="element-150">
                Valor <PriceDisplay amount="4.000" data-id="element-151" />
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-152">
              <span data-id="element-153">Bono #4: Mitos y Verdades Sobre La Caca Infantil</span>
              <span className="text-gray-400" data-id="element-154">
                Valor <PriceDisplay amount="5.000" data-id="element-155" />
              </span>
            </div>
          </div>

          <div className="text-center space-y-4" data-id="element-156">
            <div className="inline-block bg-brand-coral/10 text-brand-coral font-bold px-4 py-1.5 rounded-full text-sm animate-pulse" data-id="element-157">
              ⚠️ ATENCIÓN: Oferta de lanzamiento por tiempo limitado. El precio
              subirá pronto.
            </div>

            <div className="flex flex-col items-center justify-center space-y-1" data-id="element-158">
              <p className="text-gray-500" data-id="element-159">
                Precio regular:{' '}
                <span className="line-through" data-id="element-160">
                  <PriceDisplay amount="40.000" data-id="element-161" />
                </span>
              </p>
              <p className="font-nunito font-black text-5xl md:text-6xl text-brand-coral drop-shadow-sm" data-id="element-162">
                <PriceDisplay amount="18.999" data-id="element-163" />
              </p>
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mt-2" data-id="element-164">
                Pago único — Sin cuotas ocultas — Acceso digital inmediato
              </p>
            </div>

            <Button fullWidth className="text-xl md:text-2xl py-6 shadow-xl" data-id="element-165">
              ✅ SÍ, QUIERO EL PLAN COMPLETO AHORA →
            </Button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-500 font-medium pt-4" data-id="element-166">
              <div className="flex items-center gap-2" data-id="element-167">
                <Lock className="w-5 h-5 text-brand-green" data-id="element-168" />
                <span data-id="element-169">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-170">
                <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-171" />
                <span data-id="element-172">Garantía de 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-173">
                <span data-id="element-174">Acceso inmediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};